const semPontuacao = 0.00001;

export const perguntas = [
  {
    indice: 1,
    etapa: 0,
    tipo: 'ComboBox',
    pergunta: 'Qual a sua idade?',
    opcoes: [
      {
        label: 'Abaixo de 30 anos',
        value: 10,
      },
      {
        label: 'Entre 30 e 49 anos',
        value: 5,
      },
      {
        label: 'Acima de 50 anos',
        value: semPontuacao,
      },
    ],
  },
  {
    indice: 2,
    etapa: 0,
    tipo: 'ComboBox',
    pergunta: 'Quando você planeja se aposentar pela Forluz?',
    opcoes: [
      {
        label: 'Faltam mais de 5 anos',
        value: 20,
      },
      {
        label: 'Dentro dos próximos 5 anos',
        value: 5,
      },
      {
        label: 'Já estou aposentado, recebendo benefícios pela Forluz.',
        value: semPontuacao,
      },
    ],
  },
  {
    indice: 3,
    etapa: 0,
    tipo: 'ComboBox',
    pergunta: 'O que você busca ao investir?',
    opcoes: [
      {
        label:
          'Preservação do capital para não perder valor ao longo do tempo, assumindo baixos riscos de perdas.',
        value: semPontuacao,
      },
      {
        label:
          'Aumento gradual do capital ao longo do tempo, assumindo riscos moderados',
        value: 5,
      },
      {
        label:
          'Aumento gradual do capital, acima da taxa de retorno média do mercado, mesmo que isso implique assumir riscos de perdas elevadas.',
        value: 15,
      },
    ],
  },
  {
    indice: 4,
    etapa: 0,
    tipo: 'ComboBox',
    pergunta:
      'Defina sua formação acadêmica e experiência com mercado financeiro.',
    opcoes: [
      {
        label:
          'Possuo formação acadêmica, mas não tenho experiência com o mercado financeiro',
        value: 5,
      },
      {
        label: 'Possuo formação acadêmica e experiência no mercado financeiro',
        value: 15,
      },
      {
        label:
          'Não possuo formação acadêmica e nem experiência com o mercado financeiro',
        value: semPontuacao,
      },
    ],
  },
  {
    indice: 5,
    etapa: 1,
    tipo: 'checkbox',
    pergunta:
      'Quais investimentos você realizou nos últimos 24 meses? (Pode ser assinalada mais de 1 opção)',
    opcoes: [
      {
        label:
          'Nunca realizei nenhum tipo de investimento ou apenas em poupança.',
        value: semPontuacao,
      },
      {
        label: 'Títulos e Fundos de Investimento de Renda Fixa',
        value: 5,
      },
      {
        label: 'Fundos de Investimento de Renda Variável',
        value: 7,
      },
      {
        label: 'Bolsa de Valores ou Derivativos',
        value: 10,
      },
    ],
  },
  {
    indice: 6,
    etapa: 1,
    tipo: 'ComboBox',
    pergunta: 'O que é mais importante para você na hora de investir?',
    opcoes: [
      {
        label: 'Rentabilidade, mesmo que eu precise correr mais riscos.',
        value: 15,
      },
      {
        label: 'Rentabilidade combinada com diversificação',
        value: 5,
      },
      {
        label: 'Segurança e tranquilidade',
        value: semPontuacao,
      },
    ],
  },
  {
    indice: 7,
    etapa: 1,
    tipo: 'ComboBox',
    pergunta:
      'Se algo inesperado acontecer e suas aplicações desvalorizarem 20%, o que você faria?',
    opcoes: [
      {
        label: 'Resgataria imediatamente e aplicaria na poupança.',
        value: semPontuacao,
      },
      {
        label:
          'Manteria a aplicação aguardando uma melhora do mercado, mas sem investir recursos adicionais.',
        value: 7,
      },
      {
        label:
          'Aumentaria a aplicação para aproveitar as oportunidades de mercado.',
        value: 15,
      },
    ],
  },
];
